module.exports = __webpack_public_path__ + "img/telegram.b8dbe33d.svg";